import React from "react";
import {
  ExclamationCircleOutlined,
  InfoCircleOutlined,
  CloseCircleOutlined,
  CheckCircleOutlined,
} from "@ant-design/icons";
import { Tag, Typography } from "antd";
import { ShipmentStatus } from "@/utils/enum";

const { Text } = Typography;

const styles = {
  margin: 0,
  minWidth: 130,
  marginRight: "4px",
};

const QuoteAlert = ({ alertType, price, shipmentStatus }) => {
  switch (alertType) {
    case "completed":
      return (
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            marginRight: "4px",
          }}
        >
          {shipmentStatus <= ShipmentStatus.Completed && (
            <CheckCircleOutlined style={{ color: "#52c41a", marginRight: 5, fontSize: 16 }} />
          )}
          <Text>${price}</Text>
        </div>
      );
    case "missing":
      return (
        <Tag style={styles} icon={<ExclamationCircleOutlined />} color="warning">
          Missing Quote
        </Tag>
      );
    case "pending":
      return (
        <Tag style={styles} icon={<InfoCircleOutlined />} color="processing">
          Pending Quote
        </Tag>
      );
    case "expired":
      return (
        <Tag style={styles} icon={<CloseCircleOutlined />} color="error">
          Expired Quote
        </Tag>
      );
  }
};

export default QuoteAlert;
